<template>
  <div>
    <div class="row">PUAN: {{ point }}</div>
    <div id="goz_esnetme">
      <div
        v-for="(item, index) in row * col"
        :style="{
          width: wrapper.width / col + 'px',
          height: wrapper.height / row + 'px',
          lineHeight: wrapper.height / row + 'px',
        }"
        style="text-align: center; border-radius: 50%"
        class="dark-inverted"
        :class="getBackgroundColor(index)"
      >
        <span v-if="Math.round((col * row) / 2) - 1 != index">
          {{
            getBackgroundColor(index) == "silver"
              ? pickRandomLetter(index)
              : letterList[item - 1]
          }}
        </span>
        <span
          v-else
          style="
            width: 10px;
            height: 10px;
            background-color: gray;
            display: inline-block;
            border-radius: 50%;
          "
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "AcilanNesnelerYatay",
  data() {
    return {
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      mode: 1,
      interval: null,
      wrapper: {
        width: 0,
        height: 0,
      },
      step: 1,
      row: 13,
      col: 13,
      point: null,
      same: 1,
      letters:
        "A,B,C,Ç,D,E,F,G,Ğ,H,I,İ,J,K,L,M,N,O,Ö,P,R,S,Ş,T,U,Ü,V,Y,Z".split(","),
      letterList: [],
    };
  },
  created() {},
  mounted() {
    this.generateLetters();
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  methods: {
    getBackgroundColor(index) {
      var nums = [
        Math.round((this.col * this.row) / 2),
        Math.round((this.col * this.row) / 2) - this.row - 1,
        Math.round((this.col * this.row) / 2) - 2,
        Math.round((this.col * this.row) / 2) + this.row - 1,
      ];
      if (nums.some((k) => k === index)) {
        return "silver";
      } else {
        return "transparent";
      }
    },
    pickRandomLetter(index) {
      var nums = [
        Math.round((this.col * this.row) / 2),
        Math.round((this.col * this.row) / 2) - this.row - 1,
        Math.round((this.col * this.row) / 2) - 2,
        Math.round((this.col * this.row) / 2) + this.row - 1,
      ];
      var index = nums.findIndex((k) => k === index);
      return this.getRandomLetters[index];
    },
    generateLetters() {
      this.letterList = _.shuffle([
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
        ..._.shuffle(this.letters),
      ]);
    },
    getRandomLetters() {
      if (same == 1) {
        var letter = this.letters[_.random(0, this.letters.length)];
        return [letter, letter, letter, letter];
      } else {
        var letter = this.letters[_.random(0, this.letters.length)];
        return _.shuffle([
          this.letters[_.random(0, this.letters.length)],
          letter,
          letter,
          letter,
        ]);
      }
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      this.start();
    },
    maxStepCount: function () {
      this.step = 1;
      clearInterval(this.interval);
      this.start();
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;

  .silver {
    background-color: silver;
  }
}

.is-dark {
  .silver {
    background-color: #333 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/KareGormeAlani.vue